import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { showSnackbar } from 'actions';
import Api from 'api';
import ResetPasswordComponent from '../components/ResetPassword';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      success: false,
      hash: this.props.match.params.hash,
    };
  }

  onSubmit = async ({ password }) => {
    try {
      await Api.resetPassword({
        password,
        hash: this.state.hash,
      });

      this.setState({ success: true });
    } catch (err) {
      this.props.showSnackbar({
        severity: 'error',
        message: {
          id: err.data.message,
          defaultMessage: err.data.message,
        },
      });
    }
  };

  render() {
    return (
      <ResetPasswordComponent
        success={this.state.success}
        intl={this.props.intl}
        onSubmit={this.onSubmit}
      />
    );
  }
}

ResetPassword.propTypes = {
  showSnackbar: PropTypes.func.isRequired,
  intl: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      hash: PropTypes.string,
    }),
  }),
};

const mapDispatchToProps = (dispatch) => ({
  showSnackbar: (c) => dispatch(showSnackbar(c)),
});

export default connect(null, mapDispatchToProps)(injectIntl(ResetPassword));
